<template>
  <YearsRow v-if="state.selectedView.name != 'Jour' && state.selectedView.name != 'Semaine'"
    :slotsLength="slotsForADay.length"
  />

  <MonthsRow
    :slotsLength="slotsForADay.length"
  />

  <WeeksRow v-if="state.selectedView.name != 'Jour'"
    :slotsLength="slotsForADay.length"
  />
  
  <DaysRow v-if="state.selectedView.name == 'Jour' || state.selectedView.name == 'Semaine'"
    :slotsLength="slotsForADay.length"
  />
  
  <HourRow v-if="state.selectedView.name == 'Jour'"
    :slots="slotsForADay"
    :slotInterval="slotInterval"
    :hourMaxTime="hourMaxTime"
    :minuteWidth="minuteWidth"
  />
</template>

<script>
import HourRow from './HourRow.vue';
import DaysRow from './DaysRow.vue';
import WeeksRow from './WeeksRow.vue';
import MonthsRow from './MonthsRow.vue';
import YearsRow from './YearsRow.vue';

import { inject } from 'vue';

export default{
  components:{
    HourRow,
    DaysRow,
    WeeksRow,
    MonthsRow,
    YearsRow
  },
  setup(){
    const state = inject('state');
    return { state };
  },
  props:{
    slotsForADay: Array,
    slotInterval: Number,
    hourMaxTime: Number,
    minuteWidth: Number
  },
}
</script>